"use client";

import { useTranslations } from "next-intl";
import { createContext, useContext } from "react";

type HeroTranslateAudioNamespace = "ClientKeys.TranslateAudio" | "ClientKeys.TranslateVideo";

export interface ITranslationContext {
  t: ReturnType<typeof useTranslations<"ClientKeys.TranslateAudio">> &
    ReturnType<typeof useTranslations<"ClientKeys.TranslateVideo">>;
}

export const HeroTranslateMediaContext = createContext<ITranslationContext>({
  // @ts-expect-error - default replaced in provider
  t: () => "",
});

export function useHerotranslateMediaTranslations() {
  const ctx = useContext(HeroTranslateMediaContext);
  if (!ctx) throw new Error("useHeroTranslations must be used within a HeroTranslateMediaProvider");
  return ctx.t;
}

export function HeroTranslateMediaProvider({
  namespace,
  children,
}: {
  namespace: HeroTranslateAudioNamespace;
  children: React.ReactNode;
}) {
  const t = useTranslations(namespace);
  // Direct pass-through; no overrides needed for now
  const proxy = (...args: Parameters<ReturnType<typeof useTranslations<HeroTranslateAudioNamespace>>>) => t(...args);
  // @ts-expect-error - proxy call signature matches t
  return <HeroTranslateMediaContext.Provider value={{ t: proxy }}>{children}</HeroTranslateMediaContext.Provider>;
}
